const images = {
  deleteBtn: '/assets/components/CInput/ic-cinput-delete-btn.png',
  emailInupt: '/assets/components/CInput/ic-email-input.png',
};

export default images;
